import styled from 'styled-components';

export const PlayIcon = styled.span`
  width: 100%;
  height: 100%;
  border: 4px solid #ffffff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow:
    0 0 6px rgba(0, 0, 0, 0.3) inset,
    0 0 6px rgba(0, 0, 0, 0.3);

  &::before {
    content: '';
    border-top: solid transparent;
    border-left: solid #ffffff;
    border-bottom: solid transparent;
    border-width: 1em;
    margin-left: 6px;
    filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.3));
  }
`;
